import React, { useEffect, useState } from 'react'
import { Tab, Tabs } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useLocation } from 'react-router'
import { organizationFlowObject } from '../../../app.constant'
import ConfirmationModal from '../../../components/UI/ConfirmationModal/ConfirmationModal'
import Loading from '../../../components/UI/Loading/Loading'
import {
  getStickerSets,
  updateOrganizationFlow,
} from '../../../store/common/actions'
import {
  addEntityToKnowledgeGroup,
  deleteKnowledgeById,
} from '../../../store/knowledge/actions'
import {
  createIntent,
  getAllButtonOptions,
  getAllIntents,
  getAllUserGroups,
  getParaPhrasesBasedOnIntent,
  getParaPhrasesWithoutIntent,
  updateIntent,
  updateIntentTags,
} from '../../../store/questions/actions'
import {
  AllUserGroups,
  getIntent,
  isQuestionLoading,
} from '../../../store/questions/selector'
import ButtonsTab from './partials/ButtonsTab'
import SettingsTab from './partials/SettingsTab'
import UserSaysTab from './partials/UserSaysTab'
import VirtualAssistantTab from './partials/VirtualAssistantTab'

import AddTags from '../../../components/UI/AddTags/AddTags'
import PermissionWrapper from '../../../components/UI/PermissionWrapper/PermissionWrapper'
import { getAllUserGroupOptions } from '../../../store/notifications/actions'
import {
  getKnowledgeById,
  localUserQuestionUpdate,
} from '../../../store/questions/actions'

import { useTranslation } from 'react-i18next'
import ChildPageHeader from '@/components/UI/ChildPageHeader'
import { Button } from '@mui/material'
import { KNOWLEDGE_ALL } from '@/config'
import KGroupsTree from '@/components/UI/KGroupsTree'

const KnowledgeCreateFromScratch = (props: any) => {
  const { t } = useTranslation('translation')
  const history = useHistory()
  const dispatch = useDispatch()
  const useLocatio = useLocation()
  const questionLoading = useSelector(isQuestionLoading)
  const allUserGroupsData = useSelector(AllUserGroups)
  const intent = useSelector(getIntent)
  const [isIntentUpdating, setIsIntentUpdating] = useState(false)
  const [buttonText, setButtonText] = useState('')
  const [activeTab, setActiveTab] = useState('usersays')
  const [selectedButtonTarget, setSelectedButtonTarget] = useState(null)
  const [targetButtonsList, setTargetOptionsList] = useState([])
  const [hasAddedQuestion, setHasAddedQuestion] = useState(false)
  const [userSaysTarget, setUserSaysTarget] = useState(null)
  const [hasAddedResponse, setHasAddedResponse] = useState(false)
  const [selectedResponseTarget, setSelectedResponseTarget] = useState(null)
  const [allTags, setAllTags] = useState([])
  const [showTagsModal, setShowTagsModal] = useState(false)
  const [paraPhrasesLoading, setParaPhrasesLoading] = useState(false)

  const [generateVariations, setGenerateVariations] = useState(false)

  // Local selection for group id (replaces commonState selectedGroupId/selectedYear usage)
  const [selectedGroupId, setSelectedGroupId] = useState<string | null>(null)

  useEffect(() => {
    if (
      props.location &&
      props.location.state &&
      (props.location.state.que || props.location.state.ans)
    ) {
      if (props.location.state.que) {
        const oldList = []
        oldList.unshift({
          text: props.location.state.que,
        })
        dispatch(localUserQuestionUpdate('questions', oldList))
      }

      if (props.location.state.ans) {
        const oldResponses = []
        oldResponses.unshift({
          text: props.location.state.ans,
          group_ids: [],
        })
        dispatch(localUserQuestionUpdate('responses', oldResponses))
      }
    }
  }, [props.location])

  useEffect(() => {
    dispatch(
      updateOrganizationFlow({
        ...organizationFlowObject,
        prevRoute: '/knowledge',
        currentRoute: '/knowledge-create-from-scratch',
        nextRoute: '/knowledge/generate-questions',
        setup_completed: false,
      }),
    )

    dispatch(getAllUserGroups())
    dispatch(getStickerSets())
    dispatch(getAllUserGroupOptions()) // user groups

    setUserSaysTarget(null)
    setSelectedResponseTarget(null)
    setHasAddedQuestion(false)
    setHasAddedResponse(false)

    const query = new URLSearchParams(useLocatio.search)
    const group = query.get('group')
    const viewAll = query.get('view-all')
    setGenerateVariations(viewAll === 'true')
    if (group) {
      dispatch(localUserQuestionUpdate('knowledge_group_id', group))
    }
    return () => {
      console.log('CLEANED UP')
      dispatch({
        type: 'FETCH_KNOWLEDGE_BY_ID_SUCCESS',
        payload: {
          intent: null,
        },
      })
    }
  }, [])

  useEffect(() => {
    // Check if intent is already present dispatch locally
    const getSelectedIntent = async (selectedIntent: any) => {
      if (selectedIntent && selectedIntent.hasOwnProperty('_id')) {
        await dispatch(getKnowledgeById(selectedIntent._id))
      }
    }

    getSelectedIntent(props.selectedIntent)
    // Fetch all button options in background
    dispatch(getAllButtonOptions(true))
    dispatch(getAllIntents(true))
  }, [props.selectedIntent])

  useEffect(() => {
    // When not in edit mode, keep knowledge_group_id synced with local selectedGroupId
    if (!props.editMode && selectedGroupId) {
      dispatch(localUserQuestionUpdate('knowledge_group_id', selectedGroupId))
    }
  }, [selectedGroupId, props.editMode])

  useEffect(() => {
    if (
      !questionLoading &&
      intent &&
      props.selectedIntent &&
      props.selectedIntent.existingRecord
    ) {
      const oldList = intent.questions ? [...intent.questions] : []
      oldList.unshift({ text: props.selectedIntent.existingRecord.question })
      dispatch(localUserQuestionUpdate('questions', oldList))

      const oldResponses = intent.responses ? [...intent.responses] : []
      oldResponses.unshift({
        text: props.selectedIntent.existingRecord.answer,
        group_ids: [],
      })
      dispatch(localUserQuestionUpdate('responses', oldResponses))
    }
  }, [questionLoading])

  //
  useEffect(() => {
    buttonTextHandler()

    // If intent found updated selected state
    if (intent) {
      if (intent && intent.tags) {
        setAllTags(
          intent.tags.map((value: string) => {
            return {
              label: value,
              value,
            }
          }),
        )
      }
    }
  }, [intent])

  // Create intent
  const createIntenthandler = async () => {
    // For creation
    if (
      !props.editMode &&
      activeTab === 'usersays' &&
      (!intent || !intent.questions || intent.questions.length === 0)
    ) {
      try {
        if (selectedButtonTarget) {
          const oldButtonsList = [...targetButtonsList]
          oldButtonsList.push({
            ...selectedButtonTarget,
            name: selectedButtonTarget.name,
            type: selectedButtonTarget.type,
          })
          await dispatch(localUserQuestionUpdate('buttons', oldButtonsList))
          setSelectedButtonTarget(null)
        }

        if (userSaysTarget) {
          const oldList = []
          await oldList.unshift(userSaysTarget)
          await dispatch(localUserQuestionUpdate('questions', oldList))
          setUserSaysTarget(null)
          if (!intent || !intent.responses) {
            setHasAddedResponse(true)
            tabsChangeHandler('virtualassistant')
            return
          }
        }

        if (selectedResponseTarget) {
          const oldList = []
          await oldList.unshift(selectedResponseTarget)
          await dispatch(localUserQuestionUpdate('responses', oldList))
        }

        await setHasAddedResponse(true)
        await setHasAddedQuestion(true)
        dispatch(createIntent())
      } catch (e) {}
      return
    }

    // If questions but no responses
    if (
      !props.editMode &&
      activeTab === 'usersays' &&
      intent &&
      intent.questions &&
      intent.questions.length > 0
    ) {
      tabsChangeHandler('virtualassistant')
      return
    }

    // All good proceed
    setIsIntentUpdating(true)
    try {
      if (selectedButtonTarget) {
        const oldButtonsList = [...targetButtonsList]
        oldButtonsList.push({
          ...selectedButtonTarget,
          name: selectedButtonTarget.name,
          type: selectedButtonTarget.type,
        })
        await dispatch(localUserQuestionUpdate('buttons', oldButtonsList))
      }

      if (
        userSaysTarget &&
        userSaysTarget.text &&
        userSaysTarget.text.trim().length > 0
      ) {
        let oldList = []
        oldList = intent && intent.questions ? [...intent.questions] : []
        await oldList.unshift(userSaysTarget)
        await dispatch(localUserQuestionUpdate('questions', oldList))
      }

      if (selectedResponseTarget) {
        const oldList = []
        await oldList.unshift(selectedResponseTarget)
        await dispatch(localUserQuestionUpdate('responses', oldList))
      }

      await setHasAddedResponse(true)
      await setHasAddedQuestion(true)
      dispatch(getAllButtonOptions(true))
      await dispatch(createIntent())
      history.push(`${KNOWLEDGE_ALL}?activeTab=viewKnowledge`)
    } catch (error: any) {}
    setIsIntentUpdating(false)
  }

  const isUserSaysActivityDetected = (e: any) => {
    setUserSaysTarget({
      text: e,
    })
  }

  const isResponseActivityDetected = (e: any) => {
    setSelectedResponseTarget(e)
  }

  const isActivityDetected = (e: any, buttonsList: any[]) => {
    setSelectedButtonTarget(e)
    setTargetOptionsList([...buttonsList])
  }

  const tabsChangeHandler = (e: any) => {
    setActiveTab(e)
    buttonTextHandler(e)
    if (props.editMode) {
      setUserSaysTarget(null)
      setSelectedResponseTarget(null)
    }
  }

  const buttonTextHandler = (tab = activeTab) => {
    if (!props.editMode) {
      if (tab === 'usersays') {
        setButtonText('Next')
      } else if (tab === 'virtualassistant') {
        setButtonText('Save')
      }
    }
  }

  // Show delete modal
  const [modalShow, setModalShow] = useState(false)
  const modalhandler = (value: boolean) => {
    setModalShow(value)
  }

  const deleteConfirmed = async (
    e: React.ChangeEvent<HTMLInputElement>,
    selectedRowIds: string[],
  ) => {
    e.preventDefault()
    setModalShow(false)
    setIsIntentUpdating(true)
    await dispatch(deleteKnowledgeById(selectedRowIds, false))
    props.resetEditKnowledgehandler('reload')
    setIsIntentUpdating(false)
  }

  const updateIntenthandler = async () => {
    if (activeTab === 'level') {
      if (selectedGroupId) {
        setIsIntentUpdating(true)
        dispatch(
          addEntityToKnowledgeGroup(selectedGroupId, 'intent', [intent._id]),
        )
        setIsIntentUpdating(false)
      }
    } else {
      setIsIntentUpdating(true)
      if (selectedButtonTarget) {
        const oldButtonsList = [...targetButtonsList]
        oldButtonsList.push({
          ...selectedButtonTarget,
          name: selectedButtonTarget.name,
          type: selectedButtonTarget.type,
        })
        await dispatch(localUserQuestionUpdate('buttons', oldButtonsList))
      }

      if (
        userSaysTarget &&
        userSaysTarget.text &&
        userSaysTarget.text.trim().length > 0
      ) {
        let oldList = []
        oldList = intent && intent.questions ? [...intent.questions] : []
        await oldList.unshift(userSaysTarget)
        await dispatch(localUserQuestionUpdate('questions', oldList))
      }

      if (selectedResponseTarget) {
        const oldList = [...intent.responses]
        await oldList.unshift(selectedResponseTarget)
        await dispatch(localUserQuestionUpdate('responses', oldList))
      }

      await dispatch(updateIntent())

      // Check if intent is already present dispatch locally
      const getSelectedIntent = async (selectedIntent: any) => {
        if (selectedIntent && selectedIntent.hasOwnProperty('_id')) {
          await dispatch(getKnowledgeById(selectedIntent._id))
        }
      }

      getSelectedIntent(props.selectedIntent)
      // Fetch all button options in background
      dispatch(getAllButtonOptions(true))
      dispatch(getAllIntents(true))
      resetEditKnowledgehandler()
      setIsIntentUpdating(false)
    }
  }

  const resetEditKnowledgehandler = () => {
    dispatch({
      type: 'FETCH_KNOWLEDGE_BY_ID_SUCCESS',
      payload: {
        intent: null,
      },
    })
    props.editMode ? props.resetEditKnowledgehandler() : history.goBack()
  }

  const getParaPhrasesBasedOnIntentHandler = async () => {
    try {
      setParaPhrasesLoading(true)
      const { questions, is_paraphrased }: any = await dispatch(
        getParaPhrasesBasedOnIntent(intent?._id),
      )
      setParaPhrasesLoading(false)

      let oldQuestions: any[] = []
      if (questions.length) {
        oldQuestions = [...questions]
      }
      await dispatch(localUserQuestionUpdate('questions', oldQuestions))
      await dispatch(localUserQuestionUpdate('is_paraphrased', is_paraphrased))
    } catch (error) {
      setParaPhrasesLoading(false)
      console.log('[ error ]', error)
    }
  }

  const getParaPhrasesWithoutIntentHandler = async () => {
    try {
      setParaPhrasesLoading(true)
      let oldList: any[] = []
      let list: any = []
      if (intent && intent.questions) {
        oldList = [...intent.questions]
      }
      if (userSaysTarget) {
        await oldList.unshift(userSaysTarget)
      }

      if (oldList && oldList.length > 0) {
        for (let index = 0; index < oldList.length; index++) {
          const element = oldList[index]
          if (element?.text?.trim().length > 0) {
            list.push(element.text)
          }
        }
      } else {
        return
      }

      const { paraphrased_questions }: any = await dispatch(
        getParaPhrasesWithoutIntent(list),
      )
      setParaPhrasesLoading(false)

      let oldQuestions: any[] = []
      if (paraphrased_questions && paraphrased_questions.length > 0) {
        oldQuestions = [...paraphrased_questions]
      }
      oldQuestions = oldQuestions.map((e: any) => {
        return { text: e }
      })

      await dispatch(localUserQuestionUpdate('questions', oldQuestions))
      await dispatch(localUserQuestionUpdate('is_paraphrased', true))
    } catch (error) {
      setParaPhrasesLoading(false)
      console.log('[ error ]', error)
    }
  }

  const showAddTagHandler = () => {
    setShowTagsModal(!showTagsModal)
  }

  const confirmedTagsHandler = async (e: any, tags: any[]) => {
    e.preventDefault()
    // setQuestionUpdating(true)
    setShowTagsModal(false)
    if (props.editMode) {
      await dispatch(updateIntentTags(tags.map((t: any) => t.value)))
    } else {
      dispatch(
        localUserQuestionUpdate(
          'tags',
          tags.map((t: any) => t.value),
        ),
      )
    }
    // setQuestionUpdating(false)
  }

  // questionLoading
  if (isIntentUpdating) {
    return <Loading />
  }

  return (
    <>
      <section className="page-mid-wraper pb-0">
        {intent && intent._id && (
          <ConfirmationModal
            message={t(
              'You are deleting a question. Note that all the children of this question will also be deleted. Are you sure you want to delete?',
            )}
            size={'md'}
            show={modalShow}
            selectedRow={[intent._id]}
            onHide={() => modalhandler(false)}
            confirmHandler={deleteConfirmed}
          />
        )}

        <AddTags
          onHide={showAddTagHandler}
          show={showTagsModal}
          confirmhandler={confirmedTagsHandler}
          selectedTags={allTags}
        />

        <div>
          <ChildPageHeader
            title={
              props.editMode
                ? intent && intent.questions && intent.questions.length > 0
                  ? intent.questions[0].text
                  : intent?.name
                : t('Create Knowledge from Scratch')
            }
            subTitle={t(
              'Create knowledge by adding questions and answer variations manually.',
            )}
            hideBackButton={!!props.editMode}
            slot={{
              action: props.editMode && (
                <Button
                  color="error"
                  variant="contained"
                  onClick={() => modalhandler(true)}
                >
                  {t('Delete Question')}
                </Button>
              ),
            }}
            redirectUrl={`/knowledge/all?activeTab=viewKnowledge`}
          />
          <div className="mt-4 KnowledgeCreateFromScratch">
            <Tabs
              defaultActiveKey="usersays"
              onSelect={tabsChangeHandler}
              activeKey={activeTab}
            >
              <Tab eventKey="usersays" title={t('Questions')}>
                <UserSaysTab
                  activeTab={activeTab}
                  editMode={props.editMode}
                  isActivityDetected={isUserSaysActivityDetected}
                  hasAdded={hasAddedQuestion}
                />
              </Tab>
              <Tab
                eventKey="virtualassistant"
                title={t('Answers')}
                disabled={
                  !props.editMode &&
                  intent &&
                  ((intent.questions && intent.questions.length === 0) ||
                    !intent.questions) &&
                  allUserGroupsData.length > 0
                }
              >
                <VirtualAssistantTab
                  allUserGroups={[...allUserGroupsData]}
                  isActivityDetected={isResponseActivityDetected}
                  hasAdded={hasAddedResponse}
                  nodeElement={true}
                />
              </Tab>
              <Tab eventKey="buttons" title={t('Buttons')}>
                <ButtonsTab
                  editMode={props.editMode}
                  isActivityDetected={isActivityDetected}
                />
              </Tab>
              <Tab eventKey="level" title={t('Group')}>
                <KGroupsTree
                  actions={{ add: true }}
                  syncsState={false}
                  onSelectGroup={(group: any) =>
                    setSelectedGroupId(group?._id || null)
                  }
                />
              </Tab>
              <Tab eventKey="settings" title={t('Settings')}>
                <SettingsTab
                  editMode={props.editMode}
                  showsParentAnswer={!!props?.selectedIntent?.parent_id}
                />
              </Tab>
            </Tabs>
          </div>
          {(props.viewall || generateVariations) && (
            <div className="d-flex align-items-center flex-wrap justify-content-end mb-2">
              {paraPhrasesLoading && (
                <div className="spinner-border spinner-width-20 spinner-border-lg clr-primary mr-2"></div>
              )}

              {paraPhrasesLoading && (
                <div className="mr-auto font-16">
                  {t('Generating training phrases...  ')}
                </div>
              )}

              {intent &&
                intent._id &&
                !paraPhrasesLoading &&
                !intent.is_paraphrased &&
                activeTab === 'usersays' && (
                  <div className="mr-auto font-16">
                    {t('Looking to expand your question set?  ')}
                    <button
                      className="btn btn-link py-0"
                      disabled={paraPhrasesLoading}
                      onClick={getParaPhrasesBasedOnIntentHandler}
                    >
                      {t('Generate Variations')}
                    </button>
                  </div>
                )}
              {generateVariations &&
                intent &&
                !intent._id &&
                !paraPhrasesLoading &&
                !intent.is_paraphrased &&
                activeTab === 'usersays' && (
                  <div className="mr-auto font-16">
                    {t('Looking to expand your question set?  ')}
                    <button
                      className="btn btn-link py-0"
                      disabled={
                        paraPhrasesLoading ||
                        (!userSaysTarget && intent && !intent.questions) ||
                        (userSaysTarget?.text?.trim().length === 0 &&
                          intent &&
                          !intent.questions)
                        // intent?.questions?.length <= 0
                      }
                      onClick={getParaPhrasesWithoutIntentHandler}
                    >
                      {t('Generate Variations')}
                    </button>
                  </div>
                )}

              {props.editMode && (
                <PermissionWrapper>
                  <button
                    className="btn btn-primary mr-2"
                    onClick={updateIntenthandler}
                  >
                    {t('Save')}
                  </button>
                </PermissionWrapper>
              )}
              {!props.editMode && (
                <PermissionWrapper>
                  <button
                    className="btn btn-primary third-step"
                    onClick={createIntenthandler}
                  >
                    {props.editMode ? 'Save' : buttonText}
                  </button>
                </PermissionWrapper>
              )}
              {props.editMode && (
                <button
                  className="btn btn-outline-primary"
                  onClick={resetEditKnowledgehandler}
                >
                  {t('Cancel')}
                </button>
              )}
            </div>
          )}
        </div>
      </section>
      {!props.viewall && !generateVariations && (
        <footer>
          <div>
            <div className="d-flex align-items-center flex-wrap">
              {props.editMode && (
                <PermissionWrapper>
                  <button
                    className="btn btn-primary mr-3"
                    onClick={updateIntenthandler}
                  >
                    {t('Save')}
                  </button>
                </PermissionWrapper>
              )}
              {!props.editMode && (
                <PermissionWrapper>
                  <button
                    className="btn btn-primary third-step"
                    onClick={createIntenthandler}
                  >
                    {props.editMode ? 'Save' : buttonText}
                  </button>
                </PermissionWrapper>
              )}
              {props.editMode && (
                <button
                  className="btn btn-outline-primary ml-3"
                  onClick={resetEditKnowledgehandler}
                >
                  {t('Cancel')}
                </button>
              )}
            </div>
          </div>
        </footer>
      )}
    </>
  )
}

export default KnowledgeCreateFromScratch
